// src/EditAllianceModal.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axiosInstance from '../utils/axiosInstance';
import { API_URL } from '../utils/runtimeConfig';
import { SketchPicker } from 'react-color';
import './css/EditAllianceModal.css';

const apiUrl = API_URL
const normalizeEntityId = (value) => String(value?._id || value || '').trim();
const normalizePickerColor = (rawColor) => {
  const colorText = String(rawColor || '').trim();
  if (!colorText) return 'rgb(255, 0, 0)';
  if (colorText.startsWith('#')) return colorText;
  const parts = colorText.split(',').map((part) => Number.parseInt(part.trim(), 10));
  if (parts.length === 3 && parts.every((part) => Number.isFinite(part))) {
    return `rgb(${parts[0]}, ${parts[1]}, ${parts[2]})`;
  }
  return 'rgb(255, 0, 0)';
};

const EditAllianceModal = ({ isOpen, onRequestClose, alliance, onAllianceUpdated }) => {
  const axios = axiosInstance
  const [name, setName] = useState(alliance?.name || '');
  const [acronym, setAcronym] = useState(alliance?.acronym || '');
  const [territoryColor, setTerritoryColor] = useState(alliance?.territoryColor || '255,0,0');
  const [farmAlliance, setFarmAlliance] = useState(Boolean(alliance?.farmAlliance));

  useEffect(() => {
    setName(alliance?.name || '');
    setAcronym(alliance?.acronym || '');
    setTerritoryColor(alliance?.territoryColor || '255,0,0');
    setFarmAlliance(Boolean(alliance?.farmAlliance));
  }, [alliance]);

  const handleSave = async () => {
    try {
      const nationId = normalizeEntityId(alliance?.nation);
      if (!nationId) {
        console.error('Missing alliance nation id.');
        return;
      }
      const updatedAlliance = {
        ...alliance,
        name,
        acronym,
        territoryColor,
        farmAlliance,
      };
      await axios.put(`${apiUrl}/nations/${nationId}/alliances/${alliance._id}`, updatedAlliance);
      onAllianceUpdated();
      onRequestClose();
    } catch (error) {
      console.error('Error updating alliance:', error);
    }
  };

  const handleColorChange = (color) => {
    setTerritoryColor(`${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}`);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} contentLabel="Edit Alliance" className="edit-alliance-modal" overlayClassName="edit-alliance-modal-overlay">
      <h2>Edit Alliance</h2>
      <label>
        Name:
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <label>
        Acronym:
        <input type="text" value={acronym} onChange={(e) => setAcronym(e.target.value)} maxLength="3" />
      </label>
      <label>
        Territory Color:
        <SketchPicker color={normalizePickerColor(territoryColor)} onChangeComplete={handleColorChange} />
      </label>
      <label className="modal-checkbox">
        <input
          type="checkbox"
          checked={farmAlliance}
          onChange={(event) => setFarmAlliance(event.target.checked)}
        />
        Farm alliance
      </label>
      <button onClick={handleSave}>Save</button>
      <button onClick={onRequestClose}>Cancel</button>
    </Modal>
  );
};

export default EditAllianceModal;
